// import React, { useState,useEffect } from "react";

// const StatsButtons = ({ stats, setFilter, appliedFilters }) => {

//   const [searchStatus, setSearchStatus] = useState('')
//   useEffect(() => {
//     setSearchStatus(((appliedFilters.status) ? appliedFilters.status : ''))
//   }, [appliedFilters])
//   const handleButtonClick = (label, key) => {

//     if (appliedFilters[label]) {
//       setFilter(key, label); // Apply filter when selected
//     } else {
//       setFilter(key, label); // Remove filter when deselected
//     }

//     return appliedFilters;

//   };

//   // Function to convert camelCase to Title Case
//   const formatLabel = (label) => {
//     return label
//       .replace(/([A-Z])/g, " $1") // Add space before capital letters
//       .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
//       .trim();
//   };

//   const renderButtons = (data, prefixKeys = []) => {
//     return Object.entries(data).flatMap(([key, value]) => {

//       const newPrefixKeys = [key];
//       const filterKey = newPrefixKeys.join("_").toLowerCase(); // Create filter key format

//       if (typeof value === "object") {
//         return renderButtons(value, newPrefixKeys);
//       } else if (typeof value === "number" && value > 0) {
//         const label = newPrefixKeys.join(" > ");
//         const isSelected = appliedFilters[filterKey] || appliedFilters[label];

//         return (
//           <button
//             key={label}
//             className={`btn btn-sm btn-primary filterButton m-1 ${searchStatus === label ? "selected" : ""}`}
//             onClick={() => handleButtonClick(label, "status")}
//           >
//             {formatLabel(label)} [{value}]
//           </button>
//         );
//       }
//       return [];
//     });
//   };

//   return <div className="d-flex flex-wrap">{renderButtons(stats)}</div>;
// };

// export default StatsButtons;

import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { FaFileAlt } from "react-icons/fa";
const StatsButtons = ({ stats, setFilter, appliedFilters }) => {
  const [searchStatus, setSearchStatus] = useState('')
  useEffect(() => {
    setSearchStatus(((appliedFilters.status) ? appliedFilters.status : ''))
  }, [appliedFilters])
  const handleButtonClick = (label, key) => {
    if (appliedFilters[label]) {
      setFilter(key, label); // Apply filter when selected
    } else {
      setFilter(key, label); // Remove filter when deselected
    }

    return appliedFilters;

  };
  return <Row className="d-flex align-items-start justify-content-start w-100 mx-auto gx-3">

    {stats.total && stats.total?.members > 0 &&
      <Col xl={3} lg={6} md={6} sm={6} xs={12} className="pe-0">
        <div className="statsCard register primary mt-1 mb-1">
          <div className={`${searchStatus === 'all' ? "active statsCardTop mb-0 border-0 pb-0" : "statsCardTop mb-0 border-0 pb-0"}`} onClick={() => handleButtonClick("all", "status")}>
            <div className="left activity">    Total Members</div>
            <div className="right">
              {stats.total?.members}
            </div>
          </div>
          <div className="statsCardBottom primary">
            {stats.total?.signupRequests > 0 &&
              <div className={`${searchStatus === 'signupRequests' ? "active" : ""}`} onClick={() => handleButtonClick("signupRequests", "status")}>
                <p>  Signup Requests: </p>
                <p className="value">{stats.total?.signupRequests}</p>

              </div>}
            {stats.total?.activeMembers > 0 &&
              <div className={`${searchStatus === 'ActiveMembers' ? "active" : ""}`} onClick={() => handleButtonClick("ActiveMembers", "status")}>
                <p>  Active Members: </p>
                <p className="value">{stats.total?.activeMembers}</p>

              </div>}
            {stats.total?.inactiveMembers > 0 &&
              <div className={`${searchStatus === 'inactiveMembers' ? "active" : ""}`} onClick={() => handleButtonClick("inactiveMembers", "status")}>
                <p>  Inactive Members: </p>
                <p className="value">{stats.total?.inactiveMembers}</p>

              </div>}
          </div>
        </div>
      </Col>
    }
    {stats.signupRequests && stats.signupRequests?.total > 0 &&
      <Col xl={3} lg={6} md={6} sm={6} xs={12} className="pe-0">

        <div className="statsCard register green mt-1 mb-1">
          <div className={`${searchStatus === 'signupRequests' ? "statsCardTop mb-0 border-0 pb-0 active" : "statsCardTop mb-0 border-0 pb-0"}`} onClick={() => handleButtonClick("signupRequests", "status")}>
            <div className="left activity">   Signup Requests </div>
            <div className="right">
              {stats.signupRequests?.total}
            </div>
          </div>
          <div className="statsCardBottom green">
            {stats.signupRequests?.emailVerificationRequired > 0 &&
              <div className={`${searchStatus === 'EmailVerificationRequired' ? "active" : ""}`} onClick={() => handleButtonClick("EmailVerificationRequired", "status")}>
                <p> Email Verification Required 	: </p>
                <p className="value">{stats.signupRequests.emailVerificationRequired}</p>

              </div>}
            {stats.signupRequests?.SignupRequestsAdminActionRequired > 0 &&
              <div className={`${searchStatus === 'SignupRequest' ? "active" : ""}`} onClick={() => handleButtonClick("SignupRequest", "status")}>
                <p>  Signup Requests <span className="fontItalic fs-12">(Admin Action Required)</span>	: </p>
                <p className="value">{stats.signupRequests?.SignupRequestsAdminActionRequired}</p>

              </div>}
            {stats.signupRequests?.acceptedRequestsSignupPaymentPending > 0 &&
              <div className={`${searchStatus === 'RegistrationPaymentPending' ? "active" : ""}`} onClick={() => handleButtonClick("RegistrationPaymentPending", "status")}>
                <p>  Accepted Requests <span className="fontItalic fs-12">(Signup Payment Pending)</span>: </p>
                <p className="value">{stats.signupRequests?.acceptedRequestsSignupPaymentPending}</p>

              </div>}
            {/* {stats.signupRequests?.acceptedRequests > 0 &&
              <div className={`${searchStatus === 'acceptedRequests' ? "active" : ""}`} onClick={() => handleButtonClick("acceptedRequests", "status")}>
                <p>  Accepted Requests: </p>
                <p className="value">{stats.signupRequests?.acceptedRequests}</p>

              </div>} */}
            {stats.signupRequests?.rejectedRequests > 0 &&
              <div className={`${searchStatus === 'rejectedRequests' ? "active" : ""}`} onClick={() => handleButtonClick("rejectedRequests", "status")}>
                <p>  Rejected Requests: </p>
                <p className="value">{stats.signupRequests?.rejectedRequests}</p>

              </div>}
          </div>
        </div>
      </Col>}
    {stats.conditionalStats &&
      (
        stats.conditionalStats.renewedMembers > 0 ||
        stats.conditionalStats.membersInTolerancePeriod > 0 ||
        stats.conditionalStats.membersExpiringSoon > 0 ||
        stats.conditionalStats.membersJoinedThisYear > 0
      ) && (
        <Col xl={3} lg={6} md={6} sm={6} xs={12} className="pe-0">
          <div className="statsCard register warning mt-1 mb-1">
            <div
              className={`statsCardTop mb-0 border-0 pb-0 ${searchStatus === 'RenewedMembers' ? "active" : ""}`}
              onClick={() => handleButtonClick("RenewedMembers", "status")}
            >
              <div className="left activity">Renewed Members ({stats.conditionalStats?.renewalYear})</div>
              <div className="right">{stats.conditionalStats?.renewedMembers}</div>
            </div>
            <div className="statsCardBottom warning">
              {stats.conditionalStats?.membersInTolerancePeriod > 0 &&
                <div
                  className={`${searchStatus === 'TolerancePeriod' ? "active" : ""}`}
                  onClick={() => handleButtonClick("TolerancePeriod", "status")}
                >
                  <p>Members In Tolerance Period:</p>
                  <p className="value">{stats.conditionalStats?.membersInTolerancePeriod}</p>
                </div>}
              {stats.conditionalStats?.membersExpiringSoon > 0 && (
                <div
                  className={`${searchStatus === 'ExpiringSoon' ? "active" : ""}`}
                  onClick={() => handleButtonClick("ExpiringSoon", "status")}
                >
                  <p>Members Expiring Soon:</p>
                  <p className="value">{stats.conditionalStats?.membersExpiringSoon}</p>
                </div>
              )}
              {stats.conditionalStats?.membersJoinedThisYear > 0 && (
                <div
                  className={`${searchStatus === 'JoinedThisYear' ? "active" : ""}`}
                  onClick={() => handleButtonClick("JoinedThisYear", "status")}
                >
                  <p>Members Joined This Year:</p>
                  <p className="value">{stats.conditionalStats?.membersJoinedThisYear}</p>
                </div>
              )}
            </div>
          </div>
        </Col>
      )
    }

    {(stats.expiredMembers.expiredMembers > 0 || stats.expiredMembers?.deleteAccountRequests > 0) &&
      <Col xl={3} lg={6} md={6} sm={6} xs={12} className="">
        <div className="statsCard register danger mt-1 mb-1">
          <div className={`${searchStatus === 'ExpiredMembers' ? "statsCardTop active mb-0 border-0 pb-0" : "statsCardTop mb-0 border-0 pb-0"}`} onClick={() => handleButtonClick("ExpiredMembers", "status")}>
            <div className="left activity">    Expired Members</div>
            <div className="right ">
              {stats.expiredMembers?.expiredMembers}
            </div>
          </div>
          <div className="statsCardBottom danger">
            {/* <div className={`${searchStatus === 'ExpiredMembers' ? "active" : ""}`} onClick={() => handleButtonClick("ExpiredMembers", "status")}>
              <p>  Total Expired Members: </p>
              <p className="value">{stats.expiredMembers?.expiredMembers}</p>

            </div> */}
            <div className={`${searchStatus === 'thisYear' ? "active" : ""}`} onClick={() => handleButtonClick("thisYear", "status")}>
              <p>  Expired Members in this year: </p>
              <p className="value">{stats.expiredMembers?.thisYear}</p>

            </div>

            <div className={`${searchStatus === 'AccountDeleteRequests' ? "active" : ""}`} onClick={() => handleButtonClick("AccountDeleteRequests", "status")}>
              <p>  Account Deletion Request(s): </p>
              <p className="value">{stats.expiredMembers?.deleteAccountRequests}</p>

            </div>

          </div>
        </div>
      </Col>}
  </Row>;
};

export default StatsButtons;